import React from 'react';
import CommissionWorkflowList from './CommissionWorkflowList';

export default function CommissionReconciliationPage(props) { return <CommissionWorkflowList mode="reconciliation" {...props} />; }
